import { ModalCustom } from "components/ModalCustom";
import { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Required } from "components/Required";
import { Controller, useForm } from "react-hook-form";
import temaPadrao from "_config/temas/estilo/base";
import { PrimaryButton } from "components/Button/style";
import { yupResolver } from "@hookform/resolvers/yup";
import { alterarPlaca } from "../../validate/validator";
import { ContainerForm } from "./style";
import { CustomInput } from "components/CustomInput";
import { useMaskInput } from "hooks/useMaskInput";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmitUnitario: () => void;
  setPlacaEscolhida: (placa: null | any) => void;
  placaEscolhida: string | null;
}

export function ModalAlterarplaca({
  show,
  handleClose,
  onSubmitUnitario,
  setPlacaEscolhida,
  placaEscolhida,
}: Props) {
  const { mInputPlaca } = useMaskInput();
  const { handleSubmit, control, reset } = useForm({
    resolver: yupResolver(alterarPlaca),
  });

  useEffect(() => {
    reset({
      placa: undefined,
    });
  }, [show]);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Alterar Placa"
      centered
    >
      <form
        onSubmit={handleSubmit(() => {
          onSubmitUnitario();
        })}
      >
        <ContainerForm>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label
                  style={{ color: temaPadrao.colors.neutral.neutral70 }}
                >
                  Placa <Required />
                </Form.Label>
                <Controller
                  name="placa"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      mensagemErro={""}
                      type="text"
                      placeholder="Informe o placa"
                      style={{ height: "2.2rem" }}
                      value={value}
                      onChange={(value) => {
                        mInputPlaca(value);
                        onChange(value);
                        if (!value) {
                          setPlacaEscolhida(null);
                          return;
                        }

                        setPlacaEscolhida(value.target.value);
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </ContainerForm>
        <div className="d-flex justify-content-between gap-4 mt-4">
          <PrimaryButton
            style={{ width: "14rem" }}
            outline
            variante="primary"
            onClick={handleClose}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            style={{ width: "14rem" }}
            type="submit"
            disabled={!placaEscolhida}
          >
            Salvar
          </PrimaryButton>
        </div>
      </form>
    </ModalCustom>
  );
}
